"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickerProps = exports.textFieldProps = void 0;
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
exports.textFieldProps = {
    variant: 'outlined',
    InputLabelProps: {
        shrink: true,
    },
    fullWidth: true,
    size: 'small',
};
exports.pickerProps = {
    autoOk: true,
    variant: 'inline',
    inputVariant: 'outlined',
    format: 'dd.MM.yyyy',
    size: 'small',
    InputLabelProps: {
        shrink: true,
    },
    invalidDateMessage: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.invalidDateMessage" }),
    maxDateMessage: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ttable.maxDateMessage" }),
};
